import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Tooltip } from '@mui/material';
import Icon from '@/components/general/Icon';
import theme from '@/styles/theme';
import styles from './LogoutButton.styles';

interface LogoutComponentProps {
  handleLogout: () => void;
}

const LogoutComponent = function ({ handleLogout }: LogoutComponentProps): JSX.Element {
  return (
    <Tooltip title="Logout">
      <IconButton sx={styles} color="error" onClick={handleLogout} data-testid="logout-button">
        <Icon icon={faPowerOff} color="error" variantColor="light" size={theme.spacing(3)} />
      </IconButton>
    </Tooltip>
  );
};

export default LogoutComponent;
